const setStorageItem = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const removeStorageItem = (key) => {
  localStorage.removeItem(key);
};
const getStorageItem = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

export { setStorageItem, removeStorageItem, getStorageItem };
